module.exports = __webpack_public_path__ + "static/img/qgsd.d03b74c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/view/microFireHouse/images/prodImgs/qgsd.jpg
// module id = 7uWL
// module chunks = 21